'use client';

import { JSX, ReactNode } from 'react';

import { usePathname } from 'next/navigation';

import { Header } from '@components/Header';

import { HeaderContent, HeaderWrapper, MainLayoutWrapper } from './styles';

/**
 * MainLayout Component
 * Based on the current pathname, it renders a layout with a main content area with
 * header and children.
 */
interface MenuLayoutProps {
  children: ReactNode;
}

export const MainLayout = ({ children }: MenuLayoutProps): JSX.Element => {
  const pathname = usePathname();
  const isAdmin = pathname?.includes('/admin/') || false;

  return (
    <>
      <HeaderWrapper>
        <HeaderContent $isAdmin={isAdmin}>
          <Header />
        </HeaderContent>
      </HeaderWrapper>
      <MainLayoutWrapper>{children}</MainLayoutWrapper>
    </>
  );
};
